export default __webpack_public_path__ + "v1.18.25/static/media/green-check.c88ea47e.svg";